import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";

function init() {
    $("#edition-submit").click(function() {
        $(this).prop("disabled", true);
        
        dataaccess
            .post({
                url:
                    "/Person/" +
                    $("#personId").val() +
                    "/AddCourseEditionToPerson/" +
                    $("#add-person-editions").val()
            })
            .done(function() {
                location.reload();
            });
    });
    
    $(".remove-edition-btn").click(function() {
        $(this).prop("disabled", true);
        
        dataaccess
            .post({
                url:
                    "/Person/" +
                    $("#personId").val() +
                    "/RemoveCourseEditionFromPerson/" +
                    $(this).val()
            })
            .done(function() {
                location.reload();
            });
    });
}

export const addCourseEdition = {
    init: init
};
